import { render, staticRenderFns } from "./OptionLinkageDialog.vue?vue&type=template&id=4a872a8e&scoped=true&"
import script from "./OptionLinkageDialog.vue?vue&type=script&lang=js&"
export * from "./OptionLinkageDialog.vue?vue&type=script&lang=js&"
import style0 from "./OptionLinkageDialog.vue?vue&type=style&index=0&id=4a872a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a872a8e",
  null
  
)

export default component.exports